import React, { Component } from "react";
import { connect } from "react-redux";
import { Panel } from "react-bootstrap";

import Modal from '@sm/components/custom/Modal';
import Spinner from "@sm/components/Spinner";
import Table from "@sm/components/custom/Table";
import Toggler from '@sm/components/custom/Toggler';

import "@assets/css/apiData.css";

import * as actions from "@sm/actions";
import { crudActions } from "@sm/services/crudActions";
import { DASHBOARD_PAYOUT_ALERTS } from "@sm/actions/types";
const store = require("@sm/reducers/index");

class DashBoardPayoutAlertsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      transactions: [],
      loading: false,
      showModal: false,
      isModalLoading: false,
      modalData: "",

      columns: [
        {
          value: "date",
          label: "Date",
          isNumber: false,
          isDate: true,
          leftAligned: true,
        },
        {
          value: "timestamp",
          label: "Timestamp",
          isNumber: false,
          leftAligned: true,
        },
        {
          value: "provider",
          label: "Provider",
          isNumber: false,
          leftAligned: true,
        },
        {
          value: "merchant",
          label: "Merchant",
          isNumber: false,
          leftAligned: true,
        },
        {
          value: "midId",
          label: "MID",
          isNumber: true,
          rightAligned: true,
        },
        {
          value: "pid",
          label: "PID",
          isNumber: false,
          leftAligned: true,
        },
        {
          value: "id",
          label: "ID",
          isNumber: false,
          leftAligned: true,
        },
        {
          value: "orderId",
          label: "Order ID",
          isNumber: false,
          leftAligned: true,
        },
        {
          value: "merchant-history",
          label: "Merchant history",
          centerAligned: true,
          className: "open-modal-btn",
          buttonLabel: "View",
          isButton: true,
          endpoint: "v1/report-buttons/transactions/merchant-history",
          triggerEvent: (data, column) => this.onOpenModalClick(data, column),
          isButtonDisabled: () => { return false; },
          isButtonLoading: () => { return false; }
        },
        {
          value: "provider-history",
          label: "Provider history",
          centerAligned: true,
          className: "open-modal-btn",
          buttonLabel: "View",
          isButton: true,
          endpoint: "v1/report-buttons/transactions/provider-history",
          triggerEvent: (data, column) => this.onOpenModalClick(data, column),
          isButtonDisabled: () => { return false; },
          isButtonLoading: () => { return false; }
        },
        {
          value: "midEnabled",
          label: "MID Status",
          rightAligned: true
        }
      ],
    };
  }

  subscribeFunction = null;

  componentDidMount() {
    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().dashboardReducer;

      if (state.update === "LOADING") {
        this.setState({
          loading: true
        });
      }

      if (state.update === DASHBOARD_PAYOUT_ALERTS && this.props.thisMonth) {
        this.setState({
          transactions: state.transactions,
          loading: false
        });
        return;
      }

      if (state.update === DASHBOARD_PAYOUT_ALERTS) {
        this.setState({
          transactions: state.transactions,
          loading: false
        });
      }
    });
  };

  componentWillUnmount() {
    if (this.subscribeFunction) {
      this.subscribeFunction();
    }
  };

  tableData = () => {
    const { transactions } = this.state;

    return transactions.map(trxn => {
      return Object.assign({}, trxn, {
        midEnabled: (
          <Toggler
            active={ trxn.midEnabled }
            id={ trxn.midId }
            className="right-align"
            disabled={ true }
          />
        )
      });
    });
  };

  onOpenModalClick = (data, column) => {
    this.setState({
      isModalLoading: true,
      showModal: true,
      modalData: ""
    });
    crudActions.post(column.endpoint, { id: data.id }, {
      Company: data.companyId,
      Client: data.merchantId
    }).then(
      (response) => {
        this.setState({
          isModalLoading: false,
          modalData: JSON.parse(JSON.stringify(response))
        });
      }
    ).catch(
      (err) => {
        if (err && err.message) {
          this.props.showAlert(true, "error", err.message);
          this.setState({
            showModal: false
          });
        }
      }
    );
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      modalData: ""
    });
  };

  render() {
    const {
      columns,
      isModalLoading,
      loading,
      modalData,
      showModal
    } = this.state;
    
    return (
      <>
        <Panel style={ { height: "100%" } }>
          <Panel.Heading>
            <Panel.Title> PAYOUT ALERTS </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            {loading ? (
              <Spinner smallContainer={ true } />
            ) : (
              <div className="panel-content table-content">
                <Table
                  columns={ columns }
                  className="payout-alerts"
                  headerColor={ "#DFDFDF" }
                  data={ this.tableData() }
                  isStriped={ false }
                />
              </div>
            )}
          </Panel.Body>
        </Panel>

        <Modal
          title="Logs"
          handleClose={ this.handleCloseModal }
          showModal={ showModal }
          modalType="json"
          data={ modalData }
          isLoading={ isModalLoading }
        />
      </>
      
    );
  }
}

function mapStateToProps(state) {
  return {
    alert: state.alert
  };
};

export default connect(mapStateToProps, actions)(DashBoardPayoutAlertsComponent);
